import * as grpcWeb from '@improbable-eng/grpc-web';

const { grpc } = grpcWeb;
export const unaryTransport = grpc.CrossBrowserHttpTransport({
	withCredentials: true
});

export const serverSideStreaming = grpc.WebsocketTransport();
// export const serverSideStreaming = unaryTransport;
